import { deleteTag } from '@actions/challengeTags/deleteTag';
import { RootState } from '@reducers/index';
import {
    getChallengeTagsDeleteError,
    getChallengeTagsDeleteSuccess,
    getChallengeTagsIsDeleting,
    getTag,
} from '@selectors/challengeTags';
import usePrevious from 'lib/src/hooks/usePrevious';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { getTagRouteEndpoint } from '../utils';

const useDeleteTag = (id: number) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const tag = useSelector((state: RootState) => getTag(state, id));
    const [endpoint, setEndpoint] = useState('');
    useEffect(() => {
        if (tag.id) {
            setEndpoint(getTagRouteEndpoint(tag.type));
        }
    }, [tag]);
    const handleSubmit = useCallback(() => dispatch(deleteTag(id)), [dispatch, id]);

    const isDeleting = useSelector(getChallengeTagsIsDeleting);
    const deleteError = useSelector(getChallengeTagsDeleteError);
    const deleteSuccess = useSelector(getChallengeTagsDeleteSuccess);
    const { deleteSuccess: prevDeleteSuccess } = usePrevious({ deleteSuccess });
    useEffect(() => {
        if (!prevDeleteSuccess && deleteSuccess) {
            history.replace(`/${endpoint}`);
        }
    }, [deleteSuccess, prevDeleteSuccess, history, endpoint]);

    return { tag, handleSubmit, isDeleting, deleteError, endpoint };
};

export default useDeleteTag;
